import checkResponseOk from './checkResponseOk';

const { REACT_APP_LA2_API } = process.env;

export const fetchCountries = async () => {
	const response = await fetch(`${REACT_APP_LA2_API}/api/v1/dashboard/places/country`);
	await checkResponseOk(response);
	return await response.json();
};
